import { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import DeleteItemButton from './DeleteItemButton'

export type CommunityScrapItemNode = {
  id: string
  boardTitle?: ReactNode
  postID?: string | null
  postTitle: ReactNode
  postCommentCount?: ReactNode
  postViews?: ReactNode
  postWriterName?: ReactNode
  postCreatedAt?: ReactNode
  disabledOnClickTitle?: boolean
}

interface CommunityScrapItemProps {
  node: CommunityScrapItemNode
  onClickDeleteItem: () => void
  onClickTitle: () => void
  className?: string
}

const CommunityScrapItem: FC<CommunityScrapItemProps> = ({
  node,
  onClickDeleteItem,
  onClickTitle,
  className,
}) => {
  const {
    boardTitle,
    postCommentCount,
    postCreatedAt,
    postTitle,
    postViews,
    postWriterName,
    disabledOnClickTitle = false,
  } = node

  return (
    <StyledWrapper className={className}>
      <div className="content-wrapper">
        <div className="content-header">
          <p className="post-writer">{postWriterName}</p>
          {!!postCreatedAt && <hr className="divider" />}
          <p className="post-created-at">{postCreatedAt}</p>
        </div>
        <div
          className={disabledOnClickTitle ? 'disabled' : 'content-body'}
          onClick={() => {
            if (!disabledOnClickTitle) {
              onClickTitle()
            }
          }}
        >
          <div className="post-title">{postTitle}</div>
          <p className="post-comment-count">{postCommentCount}</p>
        </div>
        <div className="content-footer">
          <p className="board-title">{boardTitle}</p>
          <p className="post-views">{postViews}</p>
        </div>
      </div>
      <div className="button-wrapper">
        <DeleteItemButton onClick={onClickDeleteItem} />
      </div>
    </StyledWrapper>
  )
}

export default CommunityScrapItem

const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: space-between;
  padding: 20px 0px;

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: 15px 8px 15px 20px;
    `}

  .post-text {
    font-size: 12px;
    color: #999999;
  }

  .board-title {
    font-size: 12px;
    color: #333333;
  }

  .post-title {
    font-size: 16px;
    font-weight: 500;
  }

  .content-wrapper {
    display: grid;
    grid-template-rows: 1fr 1fr 1fr;
  }
  .content-header {
    display: flex;
    align-items: center;
  }

  .divider {
    border: none;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.12);
    margin: 0px;
    margin-left: 10px;
    height: 13px;
  }
  .post-writer,
  .post-created-at,
  .post-views {
    color: #999999;
    font-size: 12px;
  }

  .post-created-at {
    margin-left: 10px;
  }
  .content-body {
    display: flex;

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .disabled {
    display: flex;
    &:hover {
      text-decoration: none;
      cursor: default;
    }
  }
  .content-footer {
    display: flex;
    align-items: center;
  }

  .post-comment-count {
    font-size: 16px;
    font-weight: 500;
    margin-left: 6px;
  }
  .post-views {
    margin-left: 10px;
  }
  .button-wrapper {
    display: grid;
  }
`
